export default __webpack_public_path__ + "static/media/4.2a04aae8.png";